export default "__VITE_ASSET__b9a87e92__"